import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'adaptive-render-cta',
    templateUrl: 'adaptiveRender-cta.component.html',
    styleUrls: ['adaptiveRender-cta.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class AdaptiveRenderCta {

    @Input() data = [];

    @Output() clickEvent: EventEmitter<any> = new EventEmitter();

    constructor() { }

    ngOnInit() {}

    public get openUrl() {
        // return this.getAttrs("AdaptiveOpenUrlAction");
        return this.getAttrs("Action.OpenUrl");
    }

    public get submits() {
        return {
            // buttons: this.getAttrs("AdaptiveSubmitAction")
            buttons: this.getAttrs("Action.Submit")
        }
    }

    public get textBlock() {
        return this.getAttrs("TextBlock");
    }

    messageClicked($event) {
        this.clickEvent.emit($event);
    }

    getAttrs(type) {
        return this.data.map(el => el).filter(el => el && (el.type == type));
    }

    old_getAttrs(type) {
        return this.data.map(el => el).filter(el => el && (el.style == type));
        // return this.data.map(el => el).filter(el => el && (el.type == type));
    }
}